// TODO: Can we type a "single key" vs a "multiple key" shortcut?

let GenericHotKey = /*#__PURE__*/function (GenericHotKey) {
  GenericHotKey["Alt"] = "Alt";
  GenericHotKey["Control"] = "Ctrl";
  GenericHotKey["Meta"] = "Meta";
  GenericHotKey["Shift"] = "Shift";
  GenericHotKey["Enter"] = "Enter";
  GenericHotKey["Backspace"] = "Backspace";
  GenericHotKey["ArrowUp"] = "ArrowUp";
  GenericHotKey["ArrowDown"] = "ArrowDown";
  return GenericHotKey;
}({});
let MacHotKey = /*#__PURE__*/function (MacHotKey) {
  MacHotKey["Alt"] = "\u2325";
  MacHotKey["Control"] = "\u2303";
  MacHotKey["Meta"] = "\u2318";
  MacHotKey["Shift"] = "\u21E7";
  MacHotKey["Enter"] = "\u21B5";
  MacHotKey["Backspace"] = "\u232B";
  MacHotKey["ArrowUp"] = "\u2191";
  MacHotKey["ArrowDown"] = "\u2193";
  return MacHotKey;
}({});
let WindowsHotKey = /*#__PURE__*/function (WindowsHotKey) {
  WindowsHotKey["Alt"] = "Alt";
  WindowsHotKey["Control"] = "Ctrl";
  WindowsHotKey["Meta"] = "\u229E";
  WindowsHotKey["Shift"] = "Shift";
  WindowsHotKey["Enter"] = "Enter";
  WindowsHotKey["Backspace"] = "\u27F5";
  WindowsHotKey["ArrowUp"] = "\u2191";
  WindowsHotKey["ArrowDown"] = "\u2193";
  return WindowsHotKey;
}({});
const KEYBOARD_SHORTCUT_COMBINATOR = '+';
const KEYBOARD_SHORTCUT_COMBINATOR_REGEX = new RegExp(`\\${KEYBOARD_SHORTCUT_COMBINATOR}`, 'g');

export { GenericHotKey, KEYBOARD_SHORTCUT_COMBINATOR, KEYBOARD_SHORTCUT_COMBINATOR_REGEX, MacHotKey, WindowsHotKey };
